import Dexie from 'dexie';
import { Injectable } from '@angular/core';

export const TRAVEL_GROUPS_TABLE = 'travelGroups';
export const TRAVEL_GROUPS_LOCATIONS_TABLE = 'travelGroupsLocations';

interface IStores {
  [key: string]: string;
}

interface ISchema {
  [key: number]: IStores;
}

const version1: IStores = {};
version1[TRAVEL_GROUPS_TABLE] = 'name, data';

const version2: IStores = {};
version2[TRAVEL_GROUPS_LOCATIONS_TABLE] = 'vehicleId, currentLocation, currentState';

@Injectable({ providedIn: 'root' })
export class DbService {
  private database: Dexie;

  constructor() {
    this.open();
  }

  public get db(): Dexie {
    return this.database;
  }

  public open(): void {
    this.database = new Dexie(FV_DB_NAME);
    this.database.version(1).stores(version1);
    this.database.version(2).stores(version2);
  }

  public handleError(e: any): void {
    switch (e.name) {
    case Dexie.errnames.Abort:
      this.open();
      break;
    case Dexie.errnames.InvalidState:
      this.open();
      break;
    case Dexie.errnames.OpenFailed:
      this.open();
      break;
    default:
      break;
    }
  }

  public flushTravelGroups(): Promise<any> {
    return this.db[TRAVEL_GROUPS_TABLE].clear();
  }

  public flushTravelGroupsLocations(): Promise<any> {
    return this.db[TRAVEL_GROUPS_LOCATIONS_TABLE].clear();
  }
}
